import { FC } from 'react';
import { RadioConfig } from '../RadioGroup.types';
import FormControlLabel from 'yoda-ui/Form/FormControlLabel';
import RadioYoda from 'yoda-ui/Form/Radio';

type RadioButtonsProps = {
  radioConfigs: RadioConfig[];
};

const RadioButtons: FC<RadioButtonsProps> = ({ radioConfigs }) => {
  const buttons = radioConfigs.map((config) => {
    const { key, controlProps, label, ...formControllProps } = config;
    return (
      <FormControlLabel
        key={ key }
        control={ <RadioYoda { ...controlProps } /> }
        label={ label }
        labelPlacement="start"
        { ...formControllProps }
      />
    );
  });
  return (
    <>
      { buttons }
    </>
  );
};

export default RadioButtons;
